import { get, isExpired } from './token';

export default async () => {
  console.debug('[SSO] Is logged in: Called.');
  const result = await get() != null && !(await isExpired());
  console.debug(`[SSO] Is logged in: ${result}.`);
  return result;
};
